import { Markierung } from '@/gql/graphql';
import { t } from 'i18next';

export class Termin {
  constructor(
    readonly titel?: string,
    readonly wiederholung?: TerminWiederholung,
    readonly id?: string,
    readonly bildUrl?: string,
    readonly bildName?: string,
    readonly beschreibung?: string,
    readonly beginn?: Date,
    readonly ende?: Date,
    readonly markierung?: Markierung,
  ) {}
}

export enum TerminWiederholung {
  JAEHRLICH = 'JAEHRLICH',
  MONATLICH = 'MONATLICH',
  WOECHENTLICH = 'WOECHENTLICH',
  TAEGLICH = 'TAEGLICH',
  OHNE = 'OHNE',
}

// Die GraphQL-Enums für die Wiederholung (z.B. ArbeitszeitTermineWiederholung)
// haben dieselben Werte wie diese lokale Enum, sind aber nominal andere Typen.
// Dieser Helper prüft den Wert sicher zur Laufzeit und schließt ihn dadurch
// typsicher auf die hiesige Enum.
export function toTerminWiederholung(
  value?: string | null,
  fallback: TerminWiederholung = TerminWiederholung.OHNE,
): TerminWiederholung {
  if (!value) {
    return fallback;
  }
  return (Object.values(TerminWiederholung) as string[]).includes(value)
    ? (value as TerminWiederholung)
    : fallback;
}

export function getWiederholungStringFromTerminWiederholung(
  wiederholung: TerminWiederholung | undefined,
) {
  switch (wiederholung) {
    case TerminWiederholung.JAEHRLICH:
      return t('entities.wiederholung.jaehrlich');
    case TerminWiederholung.MONATLICH:
      return t('entities.wiederholung.monatlich');
    case TerminWiederholung.WOECHENTLICH:
      return t('entities.wiederholung.woechentlich');
    case TerminWiederholung.TAEGLICH:
      return t('entities.wiederholung.taeglich');
    case TerminWiederholung.OHNE:
      return t('entities.wiederholung.einmalig');
    default:
      return '';
  }
}
